/**
 * Little Legs Translation Helper
 * Provides translations for JavaScript-rendered content
 */
(function() {
  'use strict';
  
  // Get current locale from Shopify
  const currentLocale = window.Shopify?.locale || 'en';
  
  // Translation dictionary
  const translations = {
    'da': {
      'Buy Now': 'Køb nu',
      'Add to Cart': 'Læg i indkøbskurv',
      'Add to cart': 'Læg i indkøbskurv',
      'Checkout': 'Gå til betaling',
      'SECURE CHECKOUT': 'SIKKER BETALING',
      'Your cart': 'Din indkøbskurv',
      'Continue shopping': 'Fortsæt med at handle',
      'Update': 'Opdater',
      'Clear': 'Ryd',
      'Subtotal': 'Subtotal',
      'Total': 'Total',
      'Shipping': 'Levering',
      'Taxes': 'Skatter',
      'SAVE': 'SPAR',
      'You save': 'Du sparer',
      'Sold out': 'Udsolgt',
      'Unavailable': 'Ikke tilgængelig',
      'Select options': 'Vælg muligheder',
      'View cart': 'Se indkøbskurv',
      'Item added': 'Vare tilføjet',
      'Free': 'Gratis',
      'Added': 'Tilføjet',
      'Error': 'Fejl',
      'Max quantity': 'Max antal',
      'Updating...': 'Opdaterer...'
    },
    'en': {
      // Default English (no translation needed)
    }
  };
  
  /**
   * Translate a string to current locale
   * @param {string} text - Text to translate
   * @returns {string} - Translated text or original if no translation exists
   */
  window.t = function(text) {
    if (!text) return '';
    
    const localeTranslations = translations[currentLocale];
    if (!localeTranslations) return text;
    
    return localeTranslations[text] || text;
  };
  
  /**
   * Translate all elements with data-translate attribute
   */
  function translateElements() {
    const elements = document.querySelectorAll('[data-translate]');
    elements.forEach(el => {
      const key = el.getAttribute('data-translate');
      const translated = window.t(key);
      if (el.tagName === 'INPUT' || el.tagName === 'BUTTON') {
        el.value = translated;
      } else {
        el.textContent = translated;
      }
    });
  }
  
  // Auto-translate on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', translateElements);
  } else {
    translateElements();
  }
  
  // Export for global use
  window.LittleLegsTranslations = {
    translate: window.t,
    currentLocale: currentLocale,
    translateElements: translateElements
  };
  
})();
